import React from 'react';
import Banner from '@components/Internship/EmployersBanner/styles';

import Link from '@components/Link';
import TextHeader, { TAG, SIZE, WEIGHT } from '@components/TextHeader';
import { useTranslation } from 'next-i18next';
import Button, { BUTTON_TYPE, BUTTON_SIZE, BUTTON_THEME } from '@components/Button';

function EmployersBanner() {
  const { t } = useTranslation('internship');
  return (
    <Banner>
      <TextHeader tag={TAG.H2} size={SIZE.LG} weight={WEIGHT.NORMAL}>
        {t('Our Offer for Employers')}
      </TextHeader>
      <Button
        type={BUTTON_TYPE.BUTTON}
        size={BUTTON_SIZE.MEDIUM}
        buttonTheme={BUTTON_THEME.SECONDARY}
        href="/documents/oferta-dla-partnera-super-staze-wakacyjne-2026"
      >
        {t('See our offer')}
      </Button>
    </Banner>
  );
}

export default EmployersBanner;
